import { useEffect, useState } from 'react';
import { useSnackbar } from '../../../../contexts/snackbar.context';

export type CheckboxTax = {
  id: string;
  code: number;
  label: string;
  symbol: string;
  rate: number | null;
  extra_rate: number | null;
  included: boolean;
  created_at: string;
  updated_at: string;
  no_vat: boolean;
};

const useTaxes = (key?: string | null) => {
  const [taxes, setTaxes] = useState<CheckboxTax[]>([]);
  const { addSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchTaxes = async () => {
      if (key) {
        const res = await fetch('https://api.checkbox.in.ua/api/v1/tax', {
          method: 'GET',
          headers: {
            'X-License-Key': key,
            'X-Client-Name': 'FireMenu',
            'X-Client-Version': 'v0.1.1',
          },
        });

        const resJson = await (res.json() as Promise<CheckboxTax[] | { message: string } | null>);

        if (res.status === 200 && resJson && typeof resJson === 'object' && !('message' in resJson)) {
          setTaxes(resJson);
        } else {
          addSnackbar(resJson && 'message' in resJson ? resJson.message : 'Упс, щось пішло не так!', 'error');
        }
      }
    };

    if (key) {
      fetchTaxes();
    }
  }, [addSnackbar, key]);

  return { taxes };
};

export default useTaxes;
